// Lønn og ansatte (no).
window.PlummeI18n.register('no', {
  // ------------------------------------------------- Lonn og ansatte
  'pay.personalia': 'Personalia',
  'pay.personalInfo': 'Personopplysninger',
  'pay.edit': 'Rediger',
  'pay.documents': 'Dokumenter',
  'pay.description': 'Beskrivelse',
  'pay.contract': 'Arbeidskontrakt',
  'pay.open': 'Åpne',
  'pay.download': 'Last ned',
  'pay.delete': 'Slett',
  'pay.employment': 'Arbeidsforhold',
  'pay.positionAndAgreement': 'Stilling og avtale',
  'pay.searchOccupationCodes': 'Søk i yrkeskoder ...',
  'pay.cancel': 'Avbryt',
  'pay.saveEmployment': 'Lagre arbeidsforhold',
  'pay.employmentFrom': 'Arbeidsforhold gjelder fra',
  'pay.employmentFromHint': 'Datoen den ansatte hadde, eller skal ha, sin første arbeidsdag i foretaket ditt. Denne datoen er uavhengig av når du begynte å føre regnskap i Plumme.',
  'pay.endDate': 'Sluttdato',
  'pay.endDateHint': 'La feltet stå tomt når arbeidsforholdet fortsatt er åpent.',
  'pay.occupationCode': 'Yrkeskode',
  'pay.occupationCodeHint': 'Søk i det offentlige registeret over yrkeskoder og velg det som passer best. Feltet brukes for statistikk over yrker i Norge.',
  'pay.employmentType': 'Arbeidsforholdstype',
  'pay.employmentForm': 'Ansettelsesform',
  'pay.workingHoursScheme': 'Arbeidstidsordning',
  'pay.workingHoursSchemeHint': 'De fleste ansatte er Ikke skift, men noen vil også havne inn under de andre kategoriene.',
  'pay.hoursFullWeek': 'Timer for full uke',
  'pay.hoursFullWeekHint': 'Antall arbeidstimer i full uke hvis den ansatte jobber 100 %. Vanligvis 37,5 timer.',
  'pay.salaryType': 'Lønnstype',
  'pay.hourlyPay': 'Timelønn',
  'pay.fixedPay': 'Fastlønn',
  'pay.ftePercent': 'Stillingsprosent',
  'pay.ftePercentHint': 'Velg en estimert stillingsprosent. Er du usikker, sett nærmeste prosent.',
  'pay.fullTime': 'Heltid',
  'pay.partTime': 'Deltid',
  'pay.employmentScope': 'Stillingsomfang',
  'pay.adjustHoursBy': 'Juster timer etter',
  'pay.perWeek': 'Per uke',
  'pay.perMonth': 'Per måned',
  'pay.hoursPerWeek': 'Timer per uke',
  'pay.hoursPerMonth': 'Timer per måned',
  'pay.otherEntityNumber': 'Annet virksomhetsnummer',
  'pay.optionalEntityNumber': 'Valgfritt virksomhetsnummer',
  'pay.priorPayOutsidePlumme': 'Tidligere lønn utenom Plumme utbetalt fra foretaket ditt',
  'pay.priorPayHelp': 'Fyll kun ut lønn som ikke er registrert i Plumme, men som er utbetalt av foretaket.',
  'pay.warning': 'Advarsel:',
  'pay.forPublicStatistics': 'For offentlig statistikk - fylles kun inn om relevant',
  'pay.lastAdjustmentDate': 'Dato for siste lønnsjustering',
  'pay.salaryGrade': 'Lønnstrinn',
  'pay.salaryGradePh': 'F.eks. 45',
  'pay.agreedSalary': 'Avtalt lønn',
  'pay.save': 'Lagre',
  'pay.annualSalary': 'Årslønn',
  'pay.agreementTaxHeading': 'Avtale, feriepenger, skatt og arbeidsgiveravgift',
  'pay.tax': 'Skatt',
  'pay.notFetchedFromAltinn': 'Ikke hentet fra Altinn',
  'pay.salaryPerYear': 'Lønn per år',
  'pay.holidayPay': 'Feriepenger',
  'pay.employerContribution': 'Arbeidsgiveravgift',
  'pay.estimatedTax': 'Estimert skatt',
  'pay.estimatedAnnualCost': 'Estimert årskostnad',
  'pay.noAgreedSalary': 'Ingen avtalt lønn er lagt inn',
  'pay.taxCard': 'Skattekort',
  'pay.taxCardHelp': 'Skattekort hentes ikke ennå. Dette kobles når integrasjonen mot Skatteetaten er klar.',
  'pay.fixedLines': 'Faste linjer',
  'pay.fixedLinesHelp': 'Lønnslinjer som vanligvis er med i hver lønnsutbetaling.',
  'pay.newFixedLine': 'Opprett ny fast linje',
  'pay.seeFixedLines': 'Se faste lønnslinjer',
  'pay.payslips': 'Lønnsslipper',
  'pay.noPayslips': 'Ingen lønnsslipper er laget ennå.',
  'pay.gross': 'Brutto',
  'pay.paidOut': 'Utbetalt',
  'pay.employeePortal': 'Ansattportal',
  'pay.employeePortalSub': 'Lønnsslipper, reiser og utlegg for den ansatte.',
  'pay.needEmailFirst': 'Legg inn en gyldig e-postadresse på ansattprofilen før du gir tilgang.',
  'pay.goToTravelExpenses': 'Gå til reiser og utlegg',
  'pay.saveEmployee': 'Lagre ansatt',
  'pay.nationalId': 'Fødselsnummer',
  'pay.hasInternationalId': 'Har internasjonal ID',
  'pay.name': 'Navn',
  'pay.phone': 'Telefonnummer',
  'pay.email': 'E-post',
  'pay.address': 'Adresse',
  'pay.country': 'Land',
  'pay.address1': 'Adresse 1',
  'pay.streetAddress': 'Gateadresse',
  'pay.address2': 'Adresse 2',
  'pay.optional': 'Valgfritt',
  'pay.postalCode': 'Postnummer',
  'pay.postalPlace': 'Poststed',
  'pay.postalPlacePh': 'Poststed ...',
  'pay.accountNumber': 'Kontonummer',
  'pay.hasForeignAccount': 'Har utenlandsk kontonummer',
  'pay.mainOrSecondaryEmployer': 'Bi-/hovedarbeidsgiver',
  'pay.taxAndDutyRules': 'Skatte- og avgiftsregler',
  'pay.noteOptional': 'Notat (valgfritt)',
  'pay.notePh': 'Skriv et notat ...',
  'pay.employees': 'Ansatte',
  'pay.employeesHelp': 'Registeret over alle ansatte i foretaket. Trykk på en ansatt for å se personalia, arbeidsforhold, lønn og lønnsslipper.',
  'pay.allEmployees': 'Alle ansatte i ditt foretak',
  'pay.newEmployee': 'Ny ansatt',
  'pay.newEmployeeHelp': 'Registrer en ny ansatt med personalia, arbeidsforhold og lønnsbetingelser. Den ansatte blir da med i lønnskjøringer og a-meldingen.',
  'pay.noEmployees': 'Ingen ansatte ennå',
  'pay.salaryTypeLabel': 'Lønnstype:',
  'pay.status': 'Status',
  'pay.statusHelp': 'Aktivt ansattforhold betyr at den ansatte tas med i lønnskjøringer. Avsluttet betyr at arbeidsforholdet er opphørt.',
  'pay.payroll': 'Lønn',
  'pay.payrollSub': 'Kjør lønn, følg opp ansatte, terminer og feriepenger.',
  'pay.payrollModuleHelp': 'Lønnsmodulen samler alt om ansatte og lønn: kjøre lønn, arbeidsgiveravgift og forskuddstrekk, pensjon (OTP), feriepenger, reiser og utlegg, og innstillinger. Bytt mellom delsidene i nedtrekksmenyen.',
  'pay.payrollPages': 'Lønnssider',
  'pay.payrollPagesHelp': 'Bytt mellom delsidene i lønn — Ansatte, Lønnsutbetaling, Arbeidsgiveravgift og skatt, Pensjon/OTP, Faste lønnslinjer, Reiser og utlegg, Lønnsoversikt, Feriepengeliste, Lønnsinnstillinger og Lønnstyper.',
  'pay.employmentStatus': 'Ansattforhold',
  'pay.employmentStatusHelp': 'Viser om arbeidsforholdet er aktivt eller avsluttet. Aktive ansatte tas med i lønnskjøringer og rapporteres i a-meldingen.',
  'pay.backToPayrollRun': 'Tilbake til lønnsutbetaling',
  'pay.showAllEmployees': 'Vis alle ansatte',
  'pay.yourEmployers': 'Dine arbeidsgivere',
  'pay.yourClients': 'Dine klienter',
  'pay.bgForEmployer': 'Bakgrunnsfarge for denne arbeidsgiveren',
  'pay.bgColour': 'Bakgrunnsfarge',
  'pay.receiptHelp': 'Ta bilde, last opp, dra inn eller lim inn. Utlegg uten bilag kan ikke sendes inn.',
  'pay.takePhoto': 'Ta bilde',
  'pay.uploadFile': 'Last opp bilde/fil',
  'pay.remove': 'Fjern',
  'pay.registerExpense': 'Registrer utlegg',
  'pay.receiptRequired': 'Bilag kreves',
  'pay.category': 'Kategori',
  'pay.pickCategory': 'Velg kategori',
  'pay.date': 'Dato',
  'pay.paidWith': 'Betalt med',
  'pay.privateExpense': 'Privat utlegg',
  'pay.companyCard': 'Firmakort/driftskonto',
  'pay.amount': 'Beløp',
  'pay.currency': 'Valuta',
  'pay.whatIsExpenseFor': 'Hva gjelder utlegget?',
  'pay.registerTravel': 'Registrer reise',
  'pay.sentForApproval': 'Sendes til godkjenning',
  'pay.dateFrom': 'Dato fra',
  'pay.dateTo': 'Dato til',
  'pay.travelType': 'Reisetype',
  'pay.travelWithExpenses': 'Reise med utlegg/kjøring',
  'pay.drivingOnly': 'Bare kjøretur',
  'pay.travelWithSubsistence': 'Reise med diett',
  'pay.destination': 'Reisemål',
  'pay.destinationPh': 'By, kunde eller sted',
  'pay.from': 'Fra',
  'pay.startPlace': 'Startsted',
  'pay.to': 'Til',
  'pay.endPlace': 'Bestemmelsessted',
  'pay.kilometres': 'Kilometer',
  'pay.purpose': 'Formål',
  'pay.purposeHelp': 'Hva var formålet med reisen?',
  'pay.note': 'Notat',
  'pay.createTravelClaim': 'Opprett reiseregning',
  'pay.purposePh': 'F.eks. kundemøte i Drammen',
  'pay.whereDidYouGo': 'Hvor gikk reisen?',
  'pay.norway': 'Norge',
  'pay.tolls': 'Bompenger',
  'pay.tollsPaidWith': 'Bom betalt med',
  'pay.fromDate': 'Fra dato',
  'pay.toDate': 'Til dato',
  'pay.type': 'Type',
  'pay.hotel': 'Hotell',
  'pay.otherAccommodation': 'Annen overnatting',
  'pay.guesthouse': 'Pensjonat eller brakke',
  'pay.place': 'Sted',
  'pay.hotelOrPlace': 'Hotell eller sted',
  'pay.travelClaim': 'Reiseregning',
  'pay.rejectedByEmployer': 'Avvist av arbeidsgiver',
  'pay.newAccommodation': 'Ny overnatting',
  'pay.newTrip': 'Ny kjøretur',
  'pay.newExpense': 'Nytt utlegg',
  'pay.noLinesYet': 'Ingen linjer enda',
  'pay.employee': 'Ansatt',
  'pay.subsistence': 'Diett',
  'pay.payslip': 'Lønnsslipp',
  'pay.close': 'Lukk',
  'pay.netPaid': 'Netto utbetalt',
  'pay.period': 'Periode',
  'pay.payAndDeductions': 'Lønn og trekk',
  'pay.grossPay': 'Brutto lønn',
  'pay.withholdingTax': 'Forskuddstrekk',
  'pay.expenseRefund': 'Refusjon utlegg/reise',
  'pay.payslipPdfNote': 'PDF-visning og sending kobles når lønnsslipp-generatoren eksponeres i Plumme.',
  'pay.noPayslipsYet': 'Ingen lønnsslipper ennå.',
  'pay.myExpenses': 'Mine utlegg',
  'pay.noExpensesInView': 'Ingen utlegg i denne visningen.',
  'pay.expenses': 'Utlegg',
  'pay.preview': 'Forhåndsvis',
  'pay.loadingReceipt': 'Laster bilag...',
  'pay.canStillDownload': 'Bilaget kan fortsatt lastes ned manuelt.',
  'pay.cannotPreview': 'Denne filtypen kan ikke forhåndsvises her.',
  'pay.openNewTab': 'Åpne i ny fane',
  'pay.myTravel': 'Mine reiser',
  'pay.noTravelInView': 'Ingen reiser i denne visningen.',
  'pay.fetchingPortal': 'Henter ansattportal',
  'pay.portalFailed': 'Kunne ikke hente ansattportal',
  'pay.back': 'Tilbake',
  'pay.noEmployers': 'Ingen arbeidsgivere',
  'pay.home': 'Hjem',
  'pay.homeHelp': 'Din ansattside hos den valgte arbeidsgiveren — lønnsslipper, utlegg og reiser.',
  'pay.myPage': 'Min side',
  'pay.myPageHelp': 'Din personlige konto i Plumme — profil, virksomheter og privatøkonomi.',
  'pay.signOut': 'Logg ut',
  'pay.paidByCompanyHint': 'Bilaget sendes til bokføring, ikke til refusjon.',
  'pay.paidPrivateHint': 'Du får beløpet refundert med lønnen.',
  'pay.expenseProject': 'Prosjekt',
  'pay.expenseProjectHint': 'Utlegg på et prosjekt kan viderefaktureres kunden.',
  'pay.expenseNoProject': 'Ikke på prosjekt',
  'pay.myHours': 'Mine timer',
  'pay.hoursThisMonth': '{time} denne måneden',
  'pay.hoursHelp': 'Timene du har ført på prosjekt for denne arbeidsgiveren.',
  'pay.registerHours': 'Før timer',
  'pay.timeNew': 'Registrer timer',
  'pay.timeEdit': 'Endre time',
  'pay.timeDate': 'Dato',
  'pay.timeProject': 'Prosjekt',
  'pay.timeActivity': 'Aktivitet',
  'pay.timeHours': 'Timer',
  'pay.timeNote': 'Notat',
  'pay.timeNotePh': 'Hva jobbet du med?',
  'pay.timePickProject': 'Velg prosjekt …',
  'pay.timePickActivity': 'Velg aktivitet …',
  'pay.timeSum': 'Sum',
  'pay.timeSaved': 'Timen er lagret',
  'pay.timeDeleted': 'Timen er slettet',
  'pay.timeFailed': 'Kunne ikke lagre timen.',
  'pay.timeLocked': 'Timeføringen for denne perioden er markert som ferdig.',
  'pay.timeLockedThrough': 'Timeføringen er markert som ferdig til og med {date}.',
  'pay.timeEmptyTitle': 'Ingen timer denne uken',
  'pay.timeEmpty': 'Trykk «Registrer timer» for å føre den første.',
  'pay.timeNoProjectsTitle': 'Ingen prosjekter',
  'pay.timeNoProjects': 'Arbeidsgiveren din har ikke opprettet prosjekter du kan føre timer på ennå.',
  'pay.timePrevWeek': 'Forrige uke',
  'pay.timeNextWeek': 'Neste uke',
  'pay.myEmployeePage': 'Min ansattside',
  'pay.myEmployeePageHelp': 'Din side som ansatt hos en arbeidsgiver — atskilt fra eventuelle regnskap du fører. Her ser du lønnsslippene dine, og du registrerer utlegg og reiser du skal ha igjen for. Øverst bytter du mellom arbeidsgivere du er ansatt hos.',
  'pay.employer': 'Arbeidsgiver',
  'pay.employerHelp': 'Arbeidsgiveren denne siden gjelder. Er du ansatt flere steder, bytter du her — da viser lønnsslipper, utlegg og reiser tallene for den valgte arbeidsgiveren.',
  'pay.payslipsHelp': 'Lønnsslippene fra arbeidsgiveren — en oversikt over lønn, skattetrekk og utbetalt beløp for hver lønnskjøring. Trykk for å åpne.',
  'pay.expensesHelp': 'Utlegg du har lagt ut for av egen lomme og skal ha refundert — f.eks. en kvittering kjøpt privat. Send dem inn til godkjenning, så refunderes de via lønn.',
  'pay.travelHelp': 'Reiseregninger med kjøregodtgjørelse, diett og utlegg knyttet til en reise. Send dem inn for godkjenning og refusjon via lønn.',
  'pay.registerExpenseHelp': 'Registrer et nytt utlegg du har lagt ut for — last opp kvitteringen, angi beløp og hva det gjelder. Sendes til arbeidsgiver for godkjenning og refusjon.',
  'pay.registerTravelHelp': 'Registrer en reiseregning — kjøreturer (kilometergodtgjørelse), diett og utlegg knyttet til reisen. Sendes til arbeidsgiver for godkjenning.',

  // Employment status, special tax rules and foreign-currency expenses (2026-09-27).
  'pay.employmentStatusLabel.active': 'Aktivt ansattforhold',
  'pay.employmentStatusLabel.ended': 'Sluttet',
  'pay.employmentStatusLabel.future': 'Starter senere',
  'pay.taxRuleNotSupported': 'støttes ikke ennå',
  'pay.taxRuleNotSupportedHint': 'Plumme beregner bare ordinær skatt og arbeidsgiveravgift. En lønnskjøring med denne ansatte kan ikke godkjennes – kjør lønnen for den ansatte utenfor Plumme.',
  'pay.portalEmploymentEnded': 'Arbeidsforholdet ditt er avsluttet. Du kan fortsatt se lønnsslippene dine, men ikke sende inn nye utlegg, reiser eller timer. Ta kontakt med arbeidsgiveren hvis du har et utlegg som skal refunderes.',
  'err.employeePortal.employmentEnded': 'Arbeidsforholdet er avsluttet, og ansattportalen er nå bare for innsyn. Be arbeidsgiveren registrere utlegget.',
  'pay.foreignAmount.label': 'Beløp betalt i NOK',
  'pay.foreignAmount.hint': 'Kvitteringen er i {currency}. Oppgi hva du faktisk betalte i norske kroner, for eksempel fra kontoutskriften. Utlegget kan ikke godkjennes uten NOK-beløp.',
  'pay.foreignAmount.rateHint': 'Tilsvarer kurs {rate} NOK per {currency}.',
  'pay.foreignAmount.missing': 'NOK-beløp mangler',
  'pay.foreignAmount.missingOnApproval': 'Utlegget «{description}» er i {currency} og mangler NOK-beløp. Rediger linjen og legg inn beløpet som faktisk ble betalt i NOK før du godkjenner.',
  'err.payroll.foreignAmountMissingNok': 'Et utlegg i utenlandsk valuta mangler NOK-beløp. Legg inn beløpet som faktisk ble betalt i NOK før du godkjenner.',

  // Lonn.jsx i18n batch 1 (2026-09-29).
  'pay.tabSalaryTax': 'Lønn & skatt',
  'pay.tabPayslipsExpenses': 'Lønnsslipper & utlegg',
  'pay.taxRuleOption.ordinary': 'Vanlige',
  'pay.taxRuleOption.svalbard': 'Svalbard',
  'pay.taxRuleOption.janMayen': 'Jan Mayen og bilandene',
  'pay.taxRuleOption.seafarerDeduction': 'Særskilt fradrag for sjøfolk',
  'pay.taxRuleOption.charity': 'Veldedig eller allmennyttig organisasjon',
  'pay.taxRuleOption.netPay': 'Nettolønn',
  'pay.taxRuleOption.netPaySeafarer': 'Nettolønn for sjøfolk',
  'pay.taxRuleOption.pensionSourceTax': 'Kildeskatt på pensjoner',
  'pay.taxRuleOption.nanny': 'Dagmamma i barnets hjem',
  'pay.taxRuleOption.homeWork': 'Lønnsarbeid i hjemmet',
  'pay.taxRuleOption.taxFreeOrg': 'Skattefri organisasjon',
  'pay.employmentTypeOption.ordinary': 'Ordinært arbeidsforhold',
  'pay.employmentTypeOption.maritime': 'Maritimt arbeidsforhold',
  'pay.employmentTypeOption.freelance': 'Frilanser, oppdragstaker eller honorarperson',
  'pay.employmentTypeOption.pension': 'Pensjon eller annet trekkpliktig forhold',
  'pay.employmentTypeOption.notEmployed': 'Ikke ansatt',
  'pay.employmentTypeOption.simplifiedPrivate': 'Forenklet oppgjørsordning privat arbeidsgiver',
  'pay.employmentTypeOption.simplifiedCharity': 'Forenklet oppgjørsordning veldedig organisasjon',
  'pay.employmentTypeOption.foreignService': 'Utenlandsk tjenesteforhold',
  'pay.employmentTypeOption.boardFee': 'Styrehonorar',
  'pay.employmentFormOption.permanent': 'Fast',
  'pay.employmentFormOption.temporary': 'Midlertidig',
  'pay.employmentFormOption.temporarySubstitute': 'Midlertidig ansatt som tilkallingsvikar',
  'pay.employmentFormOption.permanentHiredOut': 'Fast ansettelse og utleid',
  'pay.employmentFormOption.temporaryHiredOut': 'Midlertidig ansettelse og utleid',
  'pay.shift.offshore': 'Offshore',
  'pay.hourlyOvertimePay': 'Timelønn - overtid',
  'pay.fixedLine': 'Fast linje',
  'pay.portalAccess.notInvited': 'Ikke gitt tilgang',
  'pay.portalAccess.active': 'Aktiv tilgang',
  'pay.portalAccess.revoked': 'Tilgang trukket tilbake',
  'pay.documentUploaded': 'Dokument lastet opp.',
  'pay.documentsUploaded': 'Dokumenter lastet opp.',
  'pay.documentDeleted': 'Dokument slettet.',
  'pay.amountRequired': 'Skriv inn et beløp.',
  'pay.fixedLineDeleted': 'Fast lønnslinje slettet.',
  'pay.fixedLineDeleteFailed': 'Kunne ikke slette fast lønnslinje.',
  'pay.emailRequiredFirst': 'Legg inn en gyldig e-postadresse på ansattprofilen først.',
  'pay.portalAccessSent': 'Tilgang sendt til {email}.',
  'pay.portalAccessRevokedToast': 'Tilgang trukket tilbake.',
  'pay.portalAccessSendFailed': 'Kunne ikke sende tilgang.',
  'pay.portalAccessRevokeFailed': 'Kunne ikke trekke tilgang tilbake.',
  'pay.saveEmployeeFailed': 'Kunne ikke lagre ansatt.',
  'pay.confirmDeleteDocument': 'Slette dokumentet "{name}"?',
  'pay.confirmDeleteFixedLine': 'Slette fast lønnslinje "{line}" for {name}?',
  'pay.confirmRevokePortalAccess': 'Trekke tilbake ansattportal-tilgang for {name}?',
  'pay.taxCardValidUntil': 'Skattekort gyldig til',
  'pay.leaveOfAbsence': 'Permisjoner',
  'pay.noLeaveRegistered': 'Ingen registrert',
  'pay.loginEmail': 'E-post for innlogging',
  'pay.lastSent': 'Sist sendt',
  'pay.revoked': 'Tilbaketrukket',
  'pay.bankAccount': 'Bankkonto',
  'pay.hoursInFullWeek': 'Timer i en full uke',
  'pay.uploading': 'Laster opp ...',
  'pay.newDocument': 'Nytt dokument',
  'pay.resendAccess': 'Send tilgang på nytt',
  'pay.grantEmployeeAccess': 'Gi ansatt tilgang',
  'pay.revoking': 'Trekker tilbake ...',
  'pay.revokeAccess': 'Trekk tilbake tilgang',
  'pay.portalAccessExplain': 'Tilgangen knyttes til ansattens e-post og ansatt-ID. Selve ansattflaten bruker denne koblingen når portalinnloggingen kobles på.',
  'pay.useStandardHolidayRate': 'Bruk standardsatsen fra lønnsinnstillinger ({rate} %)',
  'pay.priorYearSalaryHeading': 'Lønn i {year}',
  'pay.payrollDataHidden': 'Lønnsdata er skjult for denne tilgangen',
  'pay.payrollDataHiddenBody': 'Ansatte, faste lønnslinjer og lønnsutbetalinger ligger i et eget personaldokument. Rollen din på denne klienten er {role}, og appen fikk ikke lese personaldokumentet. Reiser og utlegg som er bokført som regnskap kan derfor fortsatt vises.',
  'pay.unknownAccess': 'ukjent tilgang',
  'pay.readAccess': 'Lesetilgang',
  'pay.registerFirstEmployee': 'Registrer første ansatte for å bruke lønnskjøring, skattekort og a-melding.',
  'pay.mainEmployerOption': 'Hovedarbeidsgiver',
  'pay.secondaryEmployerOption': 'Biarbeidsgiver',
  'pay.documentsCount': '{count} dokumenter',
  'pay.noDocumentsUploaded': 'Ingen opplastede dokumenter',
  'pay.cannotOpenDocument': 'Kunne ikke åpne dokument.',
  'pay.cannotDownloadDocument': 'Kunne ikke laste ned dokument.',
  'pay.endEmployment': 'Avslutt ansattforhold',
  'pay.reopenEmployment': 'Gjenåpne ansattforhold',
  'pay.earnedHolidayPayInYear': 'Opptjente feriepenger i {year}',
  'pay.holidayPayNotPaidBeforeStartHint': 'Feriepenger som ikke har blitt utbetalt før oppstartsdato i Plumme.',
  'pay.earnedTaxablePayInYear': 'Opptjent lønn (grunnlag skatt) i {year}',
  'pay.grossPayNotInPlummeHint': 'Brutto lønn utbetalt fra foretaket i {year} som ikke er ført i Plumme.',
  'pay.withheldTaxInYear': 'Trukket skatt i {year}',
  'pay.priorYearAmountWarning': 'Beløp for {year} skal kun fylles ut hvis de ikke inngår i andre lønnsutbetalinger som er ført i Plumme.',
  'pay.agreedSalaryInternalNote': 'Avtalt lønn brukes bare som intern dokumentasjon. Lønnskjøring styres av faste eller manuelle lønnslinjer.',
  'pay.estimatedAnnualSalaryFrom': 'Estimert årslønn beregnes ut fra {summary}',
  'pay.fixedLinesRegisteredCount': '{count} registrert',
  'pay.fixedLinesOnEmployee': 'Faste lønnslinjer som ligger på denne ansatte.',
  'pay.noFixedLinesRegistered': 'Det er ikke registrert noen faste linjer.',
  'pay.internalDocumentationNote': 'Dette er intern dokumentasjon. Lønnskjøring bruker faste lønnslinjer eller manuelle linjer på lønnsutbetaling.',
  'pay.noAgreedSalaryBody': 'Legg inn årslønn eller timelønn for å se estimert årskostnad, feriepenger, arbeidsgiveravgift og skatt.',
  'pay.selectOccupationCode': 'Velg yrkeskode ...',
  'pay.noOccupationCodeMatch': 'Ingen treff på "{query}".',
  'pay.editEmployeeTitle': 'Rediger ansatt',
  'pay.newEmployeeTitle': 'Ny ansatt',
});

window.PlummeI18n.register('no', {
  "err.nativeValidation.payrollManualAMelding.1": "Manuell registrering av a-melding krever norsk lønnskjøring.",
  "err.nativeValidation.payrollManualAMelding.2": "Manuell innsending må bekreftes uttrykkelig.",
  "err.nativeValidation.payrollManualAMelding.3": "Gyldig rapporteringsperiode, innsendingsdato og manuell referanse må oppgis.",
  "err.nativeValidation.payrollManualAMelding.4": "Innsendingsdatoen må være etter rapporteringsmåneden og kan ikke være i fremtiden.",
  "err.nativeValidation.payrollManualAMelding.5": "Bekreft nøyaktig de bokførte lønnskjøringene i rapporteringsmåneden.",
  "err.nativeValidation.payrollManualAMelding.6": "Den manuelle rapportreferansen er allerede registrert for denne måneden.",
  "err.nativeValidation.pensionPremiumMutation.1": "Pensjonsbetaling krever norsk regnskap i NOK.",
  "err.nativeValidation.pensionPremiumMutation.2": "Gyldig pensjonsbilag og dato må oppgis.",
  "err.nativeValidation.pensionPremiumMutation.3": "Denne pensjonsbetalingen støtter bare de kontrollerte satsene for 2026 i sone I.",
  "err.nativeValidation.pensionPremiumMutation.4": "Pensjonsbetaling bruker NOK-bankkonto 1920.",
  "err.nativeValidation.pensionPremiumMutation.5": "Pensjonsbeløp må være endelige, ikke-negative tall med hele øre.",
  "err.nativeValidation.pensionPremiumMutation.6": "Pensjonsbetalingen kan ikke registreres før regnskapsdatoen.",
  "err.nativeValidation.pensionPremiumMutation.7": "Bilagsidentiteten for pensjonen er allerede reservert.",
  "err.nativeValidation.pensionPremiumMutation.8": "Nummereringshistorikken for pensjon er ugyldig.",
});
